import styled from 'styled-components';
import { media, layout } from 'src/components/base';

export const RichTextSection = styled.section`
  &,
  p {
    font-size: ${layout.measurements.fontSizeMedium};
    font-weight: 400;
    line-height: 1.5;
    color: inherit;
  }

  p {
    margin-bottom: ${layout.measurements.spacing100};
  }

  h1 {
    font-size: 40px;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: ${layout.measurements.spacing100};

    ${media.smallOnly`
      font-size: 32px;
    `};
  }

  h2 {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.333;
    margin-bottom: ${layout.measurements.spacing100};

    ${media.smallOnly`
      font-size: 20px;
    `};
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    margin-bottom: ${layout.measurements.spacing100};

    ${media.smallOnly`
      font-size: 18px;
    `};
  }

  h4 {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: ${layout.measurements.spacing100};
  }

  h5 {
    font-size: 20px;
    font-weight: 400;
    line-height: 1.4;
    margin-bottom: ${layout.measurements.spacing100};

    ${media.smallOnly`
      font-size: 18px;
    `};
  }

  strong: {
    font-weight: 700;
  }

  ol,
  ul {
    padding-inline-start: ${layout.measurements.spacing150};

    li {
      &:not(:last-of-type) {
        margin-bottom: ${layout.measurements.spacing050};
      }
      &:last-of-type {
        margin-bottom: ${layout.measurements.spacing200};
      }
    }
  }
`;
